import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import LatestUpdateSection from './components/LatestUpdateSection';
import CategorySection from './components/CategorySection';
import TestimonialSection from './components/TestimonialSection';
import CommunityFAQSection from './components/CommunityFAQSection';
import SEOHead from '@/components/base/SEOHead';

const seoData = {
  title: '韩漫在线_免费观看韩国漫画_好看的漫画大全_韩国漫画网站',
  description: '韩漫在线,免费观看韩国漫画,好看的漫画大全,韩国漫画网站。韩国漫画网站支持韩漫在线免费观看，包含好看的漫画大全，更新频繁体验佳，让您随时随地探索各种故事并享受无限阅读乐趣。',
  keywords: '韩漫在线,免费观看韩国漫画,好看的漫画大全,韩国漫画网站',
  canonicalUrl: 'http://zaixinjiaju.com/',
  jsonLd: [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': 'http://zaixinjiaju.com/#organization',
      'name': '韩漫在线',
      'url': 'http://zaixinjiaju.com/',
      'description': '韩漫在线 - 韩国漫画免费阅读平台，每日更新，海量资源，高清画质。',
      'foundingDate': '2023-03',
      'contactPoint': {
        '@type': 'ContactPoint',
        'email': 'hello@zaixinjiaju.com',
        'contactType': 'customer service',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': 'http://zaixinjiaju.com/#website',
      'url': 'http://zaixinjiaju.com/',
      'name': '韩漫在线',
      'description': '韩国漫画网站支持韩漫在线免费观看，包含好看的漫画大全，更新频繁体验佳。',
      'inLanguage': 'zh-CN',
      'publisher': { '@id': 'http://zaixinjiaju.com/#organization' },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': 'http://zaixinjiaju.com/#webpage',
      'url': 'http://zaixinjiaju.com/',
      'name': '韩漫在线 - 韩国漫画免费阅读平台',
      'description': '韩漫在线,免费观看韩国漫画,好看的漫画大全,韩国漫画网站。',
      'isPartOf': { '@id': 'http://zaixinjiaju.com/#website' },
      'about': { '@id': 'http://zaixinjiaju.com/#organization' },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': [
        {
          '@type': 'Question',
          'name': '韩漫在线是否完全免费？',
          'acceptedAnswer': { '@type': 'Answer', 'text': '是的，韩漫在线所有漫画内容完全免费，无需注册即可在线阅读。我们致力于为所有漫画爱好者提供优质的免费阅读体验。' },
        },
        {
          '@type': 'Question',
          'name': '漫画更新频率如何？',
          'acceptedAnswer': { '@type': 'Answer', 'text': '我们保持每日更新的频率，热门漫画通常在原作更新后24小时内完成翻译和上线，确保您不错过任何精彩内容。' },
        },
        {
          '@type': 'Question',
          'name': '是否支持手机阅读？',
          'acceptedAnswer': { '@type': 'Answer', 'text': '韩漫在线采用响应式设计，完美适配手机、平板和电脑等各类设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。' },
        },
        {
          '@type': 'Question',
          'name': '如何找到我喜欢的漫画类型？',
          'acceptedAnswer': { '@type': 'Answer', 'text': '您可以通过顶部的分类导航浏览不同类型的漫画，也可以使用搜索功能快速定位您想看的作品。首页的热门推荐也能帮您发现精彩内容。' },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead {...seoData} />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommendSection />
        <LatestUpdateSection />
        <CategorySection />
        <TestimonialSection />
        <CommunityFAQSection />
      </main>
      <Footer />
    </>
  );
}